export default function isConsultant() {
  const role = localStorage.getItem("consultant.role");
  if (role === "consultant") return true;
  return false;
}
